<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <fb-tag-view @change="updateTag" :data="saveData" :class-message="messageClass" :nid="nid" />
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Tag'"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
      @collapse-click="collapsePreview"
    />
    <md-content v-show="!collapse">
      <fb-tag-view :data="saveData" />
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Help Text</label>
          <md-input v-model="tempData.help_text"></md-input>
        </md-field>
        <md-field class="fb-select">
          <label for="movie">Vocabulary</label>
          <md-select v-model="tempData.vocabulary">
            <md-option
              v-bind:key="voc.id"
              v-for="(voc) in vocabulary_list"
              :value="voc.attributes.drupal_internal__vid"
            >{{voc.attributes.name}}</md-option>
          </md-select>
        </md-field>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import FbTagView from "./FbTagView";

export default {
  name: "FbTag",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.chips =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  mounted() {
    fetch("/jsonapi/taxonomy_vocabulary/taxonomy_vocabulary")
      .then(res => {
        return res.json();
      })
      .then(json => {
        this.vocabulary_list = json.data;
      })
      .catch(() => {});
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(this.saveData.required === true && this.saveData.chips.length == 0);
      return val;
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: this.saveData.chips.map(e => e),
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  data() {
    return {
      vocabulary_list: [],
      tempData: {
        label: this.element.data.label || "",
        chips: this.element.data.chips.slice(0) || [],
        vocabulary: this.element.data.vocabulary || "",
        required: this.element.data.required || false,
        help_text: this.element.data.help_text || ""
      },
      saveData: {
        label: this.element.data.label || "",
        chips: this.element.data.chips.slice(0) || [],
        vocabulary: this.element.data.vocabulary || "",
        required: this.element.data.required || false,
        help_text: this.element.data.help_text || ""
      }
    };
  },
  components: {
    FbTagView
  },
  methods: {
    updateTag(tags) {
      this.saveData.chips = tags;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    }
  }
};
</script>

<style scoped>
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
